// 커스텀 Alert 유틸리티
// 브라우저 기본 alert 대신 커스텀 모달을 사용하여 제목을 "Alert"로 설정

let alertCallback = null;

export const setAlertCallback = (callback) => {
  alertCallback = callback;
};

export const showAlert = (message) => {
  if (alertCallback) {
    alertCallback(message);
  } else {
    // Fallback: 기본 alert 사용 (개발 중)
    window.alert(message);
  }
};

// window.alert를 오버라이드하여 커스텀 alert 사용
// 이 파일이 import되면 즉시 실행됨
if (typeof window !== 'undefined') {
  // 원본 alert 저장 (필요시 사용)
  const originalAlert = window.alert;
  
  // window.alert를 오버라이드
  window.alert = (message) => {
    // alertCallback이 설정되어 있으면 사용, 없으면 원본 alert 사용
    if (alertCallback) {
      showAlert(message);
    } else {
      // callback이 아직 설정되지 않았으면 다음 이벤트 루프에서 다시 시도
      // React가 렌더링된 후 callback이 설정될 때까지 기다림
      setTimeout(() => {
        if (alertCallback) {
          showAlert(message);
        } else {
          // 그래도 없으면 원본 alert 사용 (초기 로딩 시)
          originalAlert(message);
        }
      }, 10);
    }
  };
}

